<div class="upload">
  <label for="file-upload">
    <app-drag-indicator
      [actionType]="'Click or drag to upload your file'"
      [isHovered]="isHovered"
    ></app-drag-indicator>
    <input
      #fileInput
      (click)="fileInput.value = null"
      type="file"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      (change)="handleFileInput($event.target.files)"
      id="file-upload"
    />
  </label>
</div>
